import { g as i } from "./utils.mjs";
function r(a, t) {
  const e = i(t);
  return e !== t && (e.style.backfaceVisibility = "hidden", e.style["-webkit-backface-visibility"] = "hidden"), e;
}
export {
  r as e
};
//# sourceMappingURL=effect-target.mjs.map
